export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/74cc88c7571ddfe8037db442e45677ad.svg";